import { Outlet } from "react-router-dom";

import { BrandProvider } from "src/core/contexts/BrandContext";
import { DocumentConfigProvider } from "src/core/contexts/DocumentConfigContext";
import { UserProvider } from "src/core/contexts/UserContext";
import { TenantApolloProvider } from "src/core/graphql/client/TenantApolloProvider";

export const AppProvidersLayout = () => {
  return (
    <TenantApolloProvider>
      <UserProvider>
        <BrandProvider>
          <DocumentConfigProvider>
            <Outlet />
          </DocumentConfigProvider>
        </BrandProvider>
      </UserProvider>
    </TenantApolloProvider>
  );
};
